module.exports = __webpack_public_path__ + "static/media/you-got-it.04fe320c.png";